// extracted by mini-css-extract-plugin
export default {"container":"D_YRWU","border":"AzgDkZ","errorBorder":"Dz9zsj","disabledBorder":"DvTT9H","rotate":"sE6lc1","paused":"CL42Ub","harmonyBorder":"ouemmQ"};